<div class="landing-page-container">
  <app-breadcrumbs [isOnlyHomeActive]="true" [isDesktop]="!isMobileOrTablet"> </app-breadcrumbs>

  <app-page-content-wrapper class="landing-page-container__component" [contentPadding]="getPadding()">
    <div *ngIf="showTitle" class="landing-page-container__title-container">
      <h1 class="landing-page-container__title-container__title">
        {{ landingPageTitle }}
      </h1>
    </div>

    <!-- Storyblok dynamic component -->
    <div *ngIf="storyBody?.length" [appStoryblokEditable]="storyEditable">
      <div *ngFor="let blok of storyBody" [appStoryblokEditable]="blok._editable">
        <ndc-dynamic [ndcDynamicComponent]="components[blok.component]" [ndcDynamicInputs]="buildInputs(blok)">
        </ndc-dynamic>
      </div>
    </div>
  </app-page-content-wrapper>
</div>
